<mat-tab-group #tabs animationDuration="0ms" tabGroupDrag mat-stretch-tabs="false" mat-align-tabs="start"
               style="overflow: hidden">
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="tab-icon">list</mat-icon>
            {{ "general.files" | transloco }}
        </ng-template>
        <mat-drawer-container>
            <mat-drawer-content>
                <div class="list-container main-container">
                    <app-resource-list #appList [setResources]="resources" (toggleMinimize)="sidenav.toggle()"
                                       (fileUpload)="onSwitchFileTab()"></app-resource-list>
                </div>
            </mat-drawer-content>
            <mat-drawer [opened]="sidenavOpened" [mode]="sidenavMode" position="end" #sidenav
                        [disableClose]="sidenavMode === 'side'">
                <div class="props-container">
                    <app-resource-props [setSelectionModel]="appList.selection"
                                        (updateSelection)="appList.selection = $event"></app-resource-props>
                </div>
            </mat-drawer>
        </mat-drawer-container>
    </mat-tab>
    @if (this.accessConfig?.add !== false) {
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">backup</mat-icon>
                {{ "general.upload" | transloco }}
            </ng-template>
            <app-resource-upload [showHelpButton]="true" [category]="appList.categorySelected"></app-resource-upload>
        </mat-tab>
    }

    <mat-tab style="overflow: hidden">
        <ng-template mat-tab-label>
            <mat-icon class="tab-icon">image_search</mat-icon>
            {{ "general.stock" | transloco }}
        </ng-template>
        <app-stock-resources></app-stock-resources>
    </mat-tab>

    <mat-tab style="overflow: hidden">
        <ng-template mat-tab-label>
            <mat-icon class="tab-icon">auto_awesome</mat-icon>
            @if (experienceLevel === experienceLevelType.BEGINNER) {
                AI
            } @else {
                AI producer
            }
        </ng-template>
        <app-resources-ai></app-resources-ai>
    </mat-tab>

    <mat-tab style="overflow: hidden">
        <ng-template mat-tab-label>
            <mat-icon class="tab-icon">auto_awesome</mat-icon>
            AI animator
        </ng-template>
        <app-ai-producer></app-ai-producer>
    </mat-tab>

    <mat-tab style="overflow: hidden">
        <ng-template mat-tab-label>
            <mat-icon class="tab-icon">auto_awesome</mat-icon>
            AI video builder
        </ng-template>
        <app-ai-video-builder></app-ai-video-builder>
    </mat-tab>

</mat-tab-group>
